(function () {
  "use strict";

  var root = document.querySelector("#shopify-section-sidecart");
  if (!root) return;

  root.dataset.show = "false";
  document.body.dataset.modalMode = "false";
  document.documentElement.dataset.modalMode = "false";

  var itemsWrap = root.querySelector(".sidecart__items-wrap");
  var header = root.querySelector(".sidecart__header");
  var subtitleEl = root.querySelector("[data-sidecart-subtitle]");
  var emptyEl = root.querySelector("[data-sidecart-empty]");
  var checkoutBlock = root.querySelector("[data-sidecart-checkout-block]");
  var checkoutBtn = root.querySelector("[data-checkout]");
  var subtotalEl = root.querySelector("#sidecart-subtotal-price");
  var container = root.querySelector(".sidecart__container");
  var currencySymbols = { USD: "$", CAD: "$", EUR: "\u20ac" };
  var isOpen = false;
  var pendingLineUpdates = Object.create(null);

  function setCartEmpty(empty) {
    root.dataset.cartEmpty = empty ? "true" : "false";
    if (container) container.dataset.cartEmpty = empty ? "true" : "false";

    if (emptyEl) emptyEl.hidden = !empty;
    if (checkoutBlock) checkoutBlock.hidden = empty;

    if (subtitleEl) {
      if (empty) {
        subtitleEl.hidden = true;
        subtitleEl.textContent = "";
      }
    }
  }

  function setSubtitle(count) {
    if (!subtitleEl || count <= 0) return;
    subtitleEl.hidden = false;
    subtitleEl.textContent = count === 1 ? "1 item" : count + " items";
  }

  function setOpen(open) {
    isOpen = !!open;
    root.dataset.show = isOpen ? "true" : "false";
    document.body.dataset.modalMode = isOpen ? "true" : "false";
    document.documentElement.dataset.modalMode = isOpen ? "true" : "false";
    if (isOpen) fetchCart();
  }

  function toggleOpen() {
    setOpen(!isOpen);
  }

  function formatMoney(cents, currency) {
    var symbol = currencySymbols[currency] || "$";
    return symbol + (cents / 100).toFixed(2);
  }

  function syncHeaderCount(count) {
    document.querySelectorAll("[data-header-cart-count]").forEach(function (badge) {
      var n = parseInt(count, 10) || 0;
      badge.textContent = n > 99 ? "99+" : String(n);
      badge.hidden = n <= 0;
    });
    document.querySelectorAll("[data-open-sidecart]").forEach(function (btn) {
      btn.setAttribute(
        "aria-label",
        count > 0 ? "Cart, " + count + " item" + (count === 1 ? "" : "s") : "Cart"
      );
    });
  }


  function updateView(cart) {
    if (!itemsWrap || !cart) return;

    var isEmpty = !cart.item_count || cart.item_count === 0;
    setCartEmpty(isEmpty);
    setSubtitle(cart.item_count);

    itemsWrap.querySelectorAll(".sidecart__item").forEach(function (row) {
      var id = row.dataset.lineItemId;
      if (!cart.items.find(function (item) {
        return String(item.id) === String(id);
      })) {
        row.remove();
      }
    });

    cart.items.forEach(function (item) {
      var existing = itemsWrap.querySelector(
        '.sidecart__item[data-line-item-id="' + item.id + '"]'
      );
      if (existing) {
        var qtyInput = existing.querySelector("[data-line-item-quantity]");
        var priceEl = existing.querySelector("[data-line-item-price]");
        if (qtyInput) qtyInput.value = item.quantity;
        if (priceEl) {
          priceEl.textContent = formatMoney(item.final_line_price, cart.currency);
        }
        return;
      }

      var row = document.createElement("div");
      row.className = "sidecart__item";
      row.dataset.lineItemId = item.id;

      var image = document.createElement("div");
      image.className = "sidecart__item__image";
      if (item.image) {
        image.style.backgroundImage = "url(" + item.image + "&width=130)";
      }
      row.appendChild(image);

      var info = document.createElement("div");
      info.className = "sidecart__item__info";
      var title = document.createElement("p");
      title.className = "sidecart__item__info__title";
      title.textContent = item.title;
      info.appendChild(title);

      var qtyWrap = document.createElement("div");
      qtyWrap.className = "sidecart__item__info__quantity-container";

      var dec = document.createElement("button");
      dec.className = "sidecart__item__info__quantity-decrement";
      dec.type = "button";
      dec.dataset.lineItemDecrement = "true";
      dec.dataset.lineItemId = item.id;
      qtyWrap.appendChild(dec);

      var input = document.createElement("input");
      input.className = "sidecart__item__info__quantity-input";
      input.type = "number";
      input.min = "0";
      input.setAttribute("aria-label", "Quantity");
      input.dataset.lineItemQuantity = String(item.quantity);
      input.dataset.lineItemId = item.id;
      input.value = item.quantity;
      qtyWrap.appendChild(input);

      var inc = document.createElement("button");
      inc.className = "sidecart__item__info__quantity-increment";
      inc.type = "button";
      inc.dataset.lineItemIncrement = "true";
      inc.dataset.lineItemId = item.id;
      qtyWrap.appendChild(inc);

      info.appendChild(qtyWrap);
      row.appendChild(info);

      var total = document.createElement("div");
      total.className = "sidecart__item__total";
      var price = document.createElement("p");
      price.className = "sidecart__item__total__price";
      price.dataset.lineItemPrice = "true";
      price.dataset.lineItemId = item.id;
      price.textContent = formatMoney(item.final_line_price, cart.currency);
      total.appendChild(price);

      var remove = document.createElement("button");
      remove.textContent = "Remove";
      remove.className = "sidecart__remove-btn";
      remove.type = "button";
      remove.dataset.removeFromSidecart = "true";
      remove.dataset.lineItemId = item.id;
      total.appendChild(remove);

      row.appendChild(total);
      itemsWrap.appendChild(row);
    });

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    }

    syncHeaderCount(cart.item_count);
    bindLineItems();
  }

  function fetchCart() {
    return fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(updateView)
      .catch(function () {});
  }

  function getLineItemRow(lineId) {
    if (!itemsWrap || !lineId) return null;
    return itemsWrap.querySelector(
      '.sidecart__item[data-line-item-id="' + lineId + '"]'
    );
  }

  function setLineItemLoading(lineId, loading) {
    var row = getLineItemRow(lineId);
    if (!row) return;
    row.classList.toggle("sidecart__item--loading", !!loading);
    row.setAttribute("aria-busy", loading ? "true" : "false");
  }

  function setQuantityLoading(lineId, loading) {
    var row = getLineItemRow(lineId);
    if (!row) return;
    var qty = row.querySelector(".sidecart__item__info__quantity-container");
    if (qty) qty.classList.toggle("sidecart__item__info__quantity-container--loading", !!loading);
  }

  function setRemoveLoading(lineId, loading) {
    var row = getLineItemRow(lineId);
    if (!row) return;
    var btn = row.querySelector("[data-remove-from-sidecart]");
    if (!btn) return;
    btn.classList.toggle("sidecart__remove-btn--loading", !!loading);
    btn.setAttribute("aria-busy", loading ? "true" : "false");
    if (loading) {
      if (!btn.dataset.defaultLabel) {
        btn.dataset.defaultLabel = btn.textContent.trim();
      }
      btn.textContent = "";
    } else if (btn.dataset.defaultLabel) {
      btn.textContent = btn.dataset.defaultLabel;
    }
  }

  function updateCart(lineId, quantity, action) {
    if (!lineId || pendingLineUpdates[lineId]) {
      return Promise.resolve();
    }

    pendingLineUpdates[lineId] = true;
    setLineItemLoading(lineId, true);

    if (action === "remove") {
      setRemoveLoading(lineId, true);
    } else {
      setQuantityLoading(lineId, true);
    }

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [lineId]: quantity } })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(updateView)
      .catch(function () {})
      .finally(function () {
        delete pendingLineUpdates[lineId];
        setLineItemLoading(lineId, false);
        setQuantityLoading(lineId, false);
        setRemoveLoading(lineId, false);
      });
  }

  function setAddToCartLoading(btn, loading) {
    if (!btn) return;
    btn.setAttribute("aria-busy", loading ? "true" : "false");
    btn.classList.toggle("b2b-btn--loading", !!loading);

    if (loading) {
      if (!btn.dataset.defaultLabel) {
        btn.dataset.defaultLabel = btn.textContent.trim();
      }
      btn.textContent = "";
      if (btn.dataset.lockedDisabled !== "true") {
        btn.dataset.lockedDisabled = btn.disabled ? "true" : "false";
      }
      btn.disabled = true;
    } else {
      btn.disabled = btn.dataset.lockedDisabled === "true";
      delete btn.dataset.lockedDisabled;
      if (btn.dataset.defaultLabel) {
        btn.textContent = btn.dataset.defaultLabel;
      }
    }
  }

  function addToCart(variantId, quantity, triggerBtn) {
    if (!variantId) return Promise.resolve();

    setAddToCartLoading(triggerBtn, true);

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetchCart().then(function () {
          if (!isOpen) setOpen(true);
        });
      })
      .catch(function () {})
      .finally(function () {
        setAddToCartLoading(triggerBtn, false);
      });
  }

  function bindLineItems() {
    root.querySelectorAll("[data-remove-from-sidecart]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "true";
      btn.addEventListener("click", function () {
        if (btn.classList.contains("sidecart__remove-btn--loading")) return;
        updateCart(btn.dataset.lineItemId, 0, "remove");
      });
    });

    root.querySelectorAll("[data-line-item-increment]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "true";
      btn.addEventListener("click", function () {
        var lineId = btn.dataset.lineItemId;
        if (pendingLineUpdates[lineId]) return;
        var input = root.querySelector(
          '[data-line-item-quantity][data-line-item-id="' + lineId + '"]'
        );
        if (!input) return;
        updateCart(lineId, parseInt(input.value, 10) + 1, "quantity");
      });
    });

    root.querySelectorAll("[data-line-item-decrement]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "true";
      btn.addEventListener("click", function () {
        var lineId = btn.dataset.lineItemId;
        if (pendingLineUpdates[lineId]) return;
        var input = root.querySelector(
          '[data-line-item-quantity][data-line-item-id="' + lineId + '"]'
        );
        if (!input) return;
        var next = parseInt(input.value, 10) - 1;
        updateCart(lineId, next < 0 ? 0 : next, "quantity");
      });
    });

    root.querySelectorAll("[data-line-item-quantity]").forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = "true";
      input.addEventListener("change", function () {
        var lineId = input.dataset.lineItemId;
        if (pendingLineUpdates[lineId]) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        updateCart(lineId, qty, "quantity");
      });
    });
  }

  document.querySelectorAll("[data-open-sidecart]").forEach(function (btn) {
    btn.addEventListener("click", toggleOpen);
  });

  root.querySelectorAll("[data-close-sidecart]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      setOpen(false);
    });
  });

  function bindAddToCartButtons(scope) {
    (scope || document).querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      if (btn.dataset.boundAddToCart) return;
      btn.dataset.boundAddToCart = "true";
      btn.addEventListener("click", function () {
        if (btn.disabled || btn.classList.contains("b2b-btn--loading")) return;
        var id = btn.dataset.variantId || btn.dataset.product_id;
        if (id) addToCart(id, 1, btn);
      });
    });
  }

  bindAddToCartButtons();
  document.addEventListener("shopify:section:load", function () {
    bindAddToCartButtons();
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      window.location.href = "/checkout";
    });
  }

  if (container && container.dataset.cartEmpty === "true") {
    setCartEmpty(true);
  }
  bindLineItems();
  fetchCart();

  requestAnimationFrame(function () {
    root.classList.add("sidecart--ready");
  });
})();
